import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {EntityHeaderContainerModel} from '../../../../../../models/aggregates/erp/entity';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class EntityHeaderService extends BaseApiTemplateService<EntityHeaderContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  +  Core2Config.ERP_PREFIX + 'entity-hdrs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-hdrs';
    this.httpClient = http;
  }

  getCustomEntity(visa: ApiVisa, entityType: string):
    Observable<BasicApiResponseModel<any>> {
    let url = this.apiUrl + '/' + Core2Config.CUSTOM_PREFIX  + 'query?';
    if (entityType) {
      let url = this.apiUrl + '/' + Core2Config.CUSTOM_PREFIX  + 'query?type=' + entityType;
    }
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/' + Core2Config.CUSTOM_PREFIX  + 'query?';
      if (entityType) {
        let url = visa.api_domain_url + this.endpoint_path + '/' + Core2Config.CUSTOM_PREFIX  + 'query?' + entityType;
      }
    }
    return this.httpClient.get<BasicApiResponseModel<any>>
    (url, this.getHttpHeader(visa));
  }

  getEntity(
    type: any,
    guid:any,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    let url = visa.api_domain_url + this.endpoint_path+'/'+ type+'s/' + guid;
    return this.httpClient.get<BasicApiResponseModel<any>>(
      url, this.getHttpHeader(visa)
    );
  }

  getEntityByHdrGuids(guid: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let url = visa.api_domain_url + this.endpoint_path + '/query?hdr_guids=' + guid;
    return this.httpClient.get<BasicApiResponseModel<any>>(
      url, this.getHttpHeader(visa)
    );
  }

}
